<template>
    <v-expand-transition>
        <div v-show="visible">
            <v-divider></v-divider>
            <v-card-text class="pa-4">
                <div v-if="loading" class="text-center py-4">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <div v-else-if="fieldsset">
                    <fields-generator
                        :fieldsset.sync="fieldsset"
                        :model.sync="model"
                        :selectChange="onFieldChange"
                        :support="support"
                        :force-tinymce="true"
                        ref="fieldsgenerator"
                    ></fields-generator>
                    <small class="px-4">* Indica i campi obbligatori</small>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn text @click="$emit('cancel')" :disabled="saving">
                    Annulla
                </v-btn>
                <v-btn
                    color="primary"
                    @click="save"
                    :loading="saving"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    Salva Triage
                </v-btn>
            </v-card-actions>
        </div>
    </v-expand-transition>
</template>

<script>
import FieldsGenerator from '@/components/common/FieldsGenerator'

export default {
    name: 'TriagePanel',

    components: {
        FieldsGenerator
    },

    props: {
        ticketId: {
            type: Number,
            required: true
        },
        visible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            saving: false,
            fieldsset: null,
            model: {},
            support: {},
        }
    },

    watch: {
        visible(newVal) {
            if (newVal && !this.fieldsset) {
                this.loadFields()
            }
        }
    },

    methods: {
        loadFields() {
            this.loading = true
            this.axios.get(`helpdesktroubles-triage/${this.ticketId}`)
                .then(response => {
                    this.fieldsset = response.data.fields
                    this.model = response.data.model || {}
                })
                .catch(error => {
                    console.error('Error loading triage fields:', error)
                    this.$emit('cancel')
                })
                .finally(() => {
                    this.loading = false
                })
        },

        save() {
            this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                if (!result) return

                this.saving = true
                this.axios.put(`helpdesktroubles-updatetriage/${this.ticketId}`, this.model)
                    .then(response => {
                        this.$store.commit('setSnackbar', {
                            value: true,
                            text: 'Triage aggiornato',
                            color: 'success',
                            timeout: 3000
                        })
                        this.$emit('saved', response.data.model)
                    })
                    .catch(error => {
                        console.error('Error saving triage:', error)
                    })
                    .finally(() => {
                        this.saving = false
                    })
            })
        },

        onFieldChange(field, event) {
            // Gestione cascade fields (company → destination, asset, contract, etc.)
            if (this.$eventBusUtility && this.$eventBusUtility.fieldsGeneratorConditions) {
                Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(
                    field, event, this.fieldsset, this.model, this.support
                )).then(responses => {
                    responses.forEach(response => {
                        if (this.model[response.key] && this.$refs.fieldsgenerator) {
                            const ref = this.$refs.fieldsgenerator.$refs[response.key]
                            if (ref && ref[0]) {
                                ref[0].$emit('change', this.model[response.key])
                            }
                        }
                    })
                })
            }
        },

        reset() {
            this.fieldsset = null
            this.model = {}
        }
    }
}
</script>
